<div
  class="wrapper position-relative"
  [class.scrollable]="scrollable"
  [class.centered]="centered"
  [class.has-scroll]="scrollableElement?.scrollWidth > scrollableElement?.clientWidth"
  [style.--gallery-view-item-size.px]="size"
>
  <button *ngIf="scrollable && showPrevArrow" class="to-left br-16 position-absolute" (click)="scrollLeft()"></button>

  <div
    class="gallery"
    #scrollableElement
    [style.gap.px]="gap"
    (scrollend)="scrollEndEvent()"
  >
    <div
      *ngFor="let item of previewImages; let index = index"
      class="gallery-item"
      [class.active]="index === activeIndex"
    >
      <img [src]="item.fileName.url" class="cursor-pointer" (click)="clickedOnItemHandler(index)" alt="image" />
    </div>

    <ng-container *ngIf="!scrollable && extraImageCount > 0">
      <div
        *ngIf="images[4] as item"
        class="gallery-item extra fz-16 lh-24 fw-500 position-relative overflow-hidden cursor-pointer"
        [class.active]="activeIndex >= 4"
      >
        <img [src]="item.fileName.url" alt="image" />
        <div
          class="extra position-absolute w-100 h-100"
          (click)="clickedOnExtraHandler(activeIndex < 4 ? 4 : activeIndex)"
        >+{{ extraImageCount }}</div>
      </div>
    </ng-container>
  </div>

  <button *ngIf="scrollable && showNextArrow" class="to-right br-16 position-absolute" (click)="scrollRight()"></button>
</div>
